export interface BudgetPlanCardsProps {
    heading: string;
    description: string;
    image: string;
    image_alt: string;
    button: string;
    href: string;
}

export interface BudgetPlanCardsContentProps {
    h1: string;
    para1: string;
    para2: string;
}




export const BudgetPlanCardsContent: BudgetPlanCardsContentProps = {
    h1: "Integrating your budget with other wedding planning tools",
    para1: "Integrating your wedding budget template with other planning tools ensures a comprehensive and cohesive approach. Tools like checklists, vendor managers, and guest list managers work harmoniously with your budget, improving the planning process.",
    para2: "This integration helps manage all aspects of your wedding seamlessly. See below for a few of our other free wedding planning templates to help make wedding planning easy.",

}
export const BudgetPlanCardsData: BudgetPlanCardsProps[] = [
    {
        heading: "All-In-One Wedding Planning Template",
        description: "Complete wedding planning template covering 25+ essentials areas including budget, guest list, seating plan and more. Make wedding planning fun and easy with this template.",
        image: "https://cdn.buttercms.com/tzS6nEBSIyeoF6hfnW7o?calv=v3-default 1x, https://cdn.buttercms.com/tzS6nEBSIyeoF6hfnW7o?calv=v3-default 2x",
        image_alt: "Future bride and groom sitting at their home dining room table with a dream wedding plan vision displayed on the laptop screen.",
        button: "Get Template",
        href: "/wedding-planning-template"
    },
    {
        heading: "Wedding Day Emergency Kit",
        description: "Emergencies happen on wedding day. Big or small, we have you covered! Complete list of items for the bride and groom to pack for those common “just in case” situations.",
        image: "https://cdn.buttercms.com/49NhYESTpujYlJt8vKAg?calv=v3-default 1x, https://cdn.buttercms.com/49NhYESTpujYlJt8vKAg?calv=v3-default 2x",
        image_alt: "A bride unpacking her wedding day emergency kit on wedding day.",
        button: "Get Template",
        href: "/wedding-day-emergency-kit"
    },
    {
        heading: "Free Wedding Floral Quote",
        description: "Wedding florals covered? Get a quick, free online quote that you can use to compare vs. other vendors. No price gatekeeping. No minimums. No funny business.",
        image: "https://cdn.buttercms.com/aavFj2OmSh6AeXBm5tdR?calv=v3-default 1x, https://cdn.buttercms.com/aavFj2OmSh6AeXBm5tdR?calv=v3-default 2x",
        image_alt: "Free Wedding Floral Quote image",
        button: "Get Floral Quote",
        href: "/wedding-flowers"
    },


]